import { ImageFormatKey } from '@/resources/image-format';
import { defineStore } from 'pinia';

export const useFormatsStore = defineStore('formats-store', {
  state: () => ({
    formats: {} as Record<string, ImageFormatKey>
  }),
  getters: {
    format(state) {
      return (basename: string) => {
        return state.formats[basename];
      };
    }
  },
  actions: {
    sync(formats: Record<string, ImageFormatKey>) {
      this.formats = { ...formats };
    },
    add(basename: string, format: ImageFormatKey) {
      this.formats[basename] = format;
    }
  }
});
